import { isOneOf } from '@pba/react-utils';
import { supportedAppLanguageCodes } from './config';

export const isAppLanguage = (lang: string) => isOneOf(lang, supportedAppLanguageCodes);
